import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorResponseTypes } from "../middlewares/errorResponseTypes";

export const errorResponseSliceName = "errorResponse";

export interface ErrorResponseState {
  errorResponses: ErrorResponseTypes[];
}

const initialState: ErrorResponseState = {
  errorResponses: [],
};

const errorResponseSlice = createSlice({
  name: errorResponseSliceName,
  initialState,
  reducers: {
    addErrorResponse(state: ErrorResponseState, action: PayloadAction<ErrorResponseTypes>) {
      // side effect in reducer: log (instant console feedback) + store (user feedback from store data via dialog)
      console.warn(`Received ${action.payload.type} error response:`, action.payload);
      state.errorResponses = [...state.errorResponses, action.payload];
    },
    removeErrorResponse(state: ErrorResponseState, action: PayloadAction<ErrorResponseTypes>) {
      const queryJSON = JSON.stringify(action.payload);
      const queryIndex = state.errorResponses.findIndex((it) => JSON.stringify(it) === queryJSON);
      state.errorResponses = state.errorResponses.filter((_, index) => index !== queryIndex);
    },
    discardFirstErrorResponse(state: ErrorResponseState) {
      state.errorResponses = state.errorResponses.filter((_, index) => index > 0);
    },
    clearErrorResponses(state: ErrorResponseState) {
      state.errorResponses = [];
    },
  },
});

export interface ErrorResponseRootState {
  [errorResponseSliceName]: ErrorResponseState;
}

export const selectErrorResponse = (state: ErrorResponseRootState) => state[errorResponseSliceName];
export const selectFirstErrorResponse = (state: ErrorResponseRootState) => {
  const { errorResponses } = selectErrorResponse(state);
  return errorResponses.length > 0 ? errorResponses[0] : null;
};

export const {
  addErrorResponse,
  removeErrorResponse,
  discardFirstErrorResponse,
  clearErrorResponses,
} = errorResponseSlice.actions;

export const errorResponseReducer = errorResponseSlice.reducer;
